<div class="announcement-info" *ngIf="!isClosed && latestAnnouncement$ | async as announcements">
    <ngb-carousel>
        <ng-template ngbSlide *ngFor="let announcement of announcements; let i = index">
            <div class="announcement-wrapper">
                <a *ngIf="announcement.link; else noLink" #announcementText class="announcement-text"
                    href="{{announcement.link}}" target="_blank" appInsightsTrack [eventData]="{
                            title: announcement.message,
                            link: announcement.link
                        }" loc="announcement" (mouseenter)="startScrollText($event)"
                    (mouseleave)="stopScrollText($event)">
                    {{announcement.message}}
                </a>
                <ng-template #noLink>
                    <span #announcementText class="announcement-text" (mouseenter)="startScrollText($event)"
                        (mouseleave)="stopScrollText($event)">
                        {{announcement.message}}
                    </span>
                </ng-template>
            </div>
        </ng-template>
    </ngb-carousel>
    <mat-icon svgIcon="hub_close" (click)="close()">
    </mat-icon>
</div>
<div class="header" #header></div>